/*------------------------------------*/
/*       TIPOS DE MIEMBRO (BITS)      */
/*------------------------------------*/

// id_tipo es un campo de bits: bit N (1-indexado desde el LSB) = peso 2^(N-1).
// Los bits 2 y 4 comparten etiqueta, por eso getMemberTypeKeys deduplica.
export const MEMBER_TYPE_BITS = [
    { bit: 1,  key: 'memberTypes.abonado' },
    { bit: 2,  key: 'memberTypes.soyBeticoDigital' },
    { bit: 3,  key: 'memberTypes.soyBetico' },
    { bit: 4,  key: 'memberTypes.soyBeticoDigital' },
    { bit: 5,  key: 'memberTypes.accionista' },
    { bit: 6,  key: 'memberTypes.empleado' },
    { bit: 7,  key: 'memberTypes.voluntario' },
    { bit: 8,  key: 'memberTypes.clubNegocios' },
    { bit: 9,  key: 'memberTypes.clienteEcommerce' },
    { bit: 10, key: 'memberTypes.clienteTicketing' },
];

export const hasBit = (value, bit) => (Number(value) & (1 << (bit - 1))) !== 0;

export const getMemberTypeKeys = (value) => [
    ...new Set(MEMBER_TYPE_BITS.filter(({ bit }) => hasBit(value, bit)).map(({ key }) => key)),
];
